<template>
  <div
    class="animation-group"
    :class="animationClass"
    v-if="imgList.length > 0"
  >
    <div
      class="animation-group__item g-item"
      :class="playAni && 'ani-x'"
      v-for="(imgObj, idx) in imgList"
      :key="idx"
      :style="{
        left: $pxToVw(imgObj.left),
        top: $pxToVw(imgObj.top),
        right: $pxToVw(imgObj.right),
        bottom: $pxToVw(imgObj.bottom),
        width: $pxToVw(imgObj.width),
        height: $pxToVw(imgObj.height),
        animationDelay: idx * 0.088 + 's',
        transitionDelay: idx * 0.07 + 's',
      }"
    >
      <van-image
        class="animation-group__item-inner g-inner"
        :class="playAni && 'ani-y'"
        :src="imgObj.src"
        :width="$pxToVw(imgObj.size) || 64"
        :style="{
          animationDelay: idx * 0.088 + 's',
          transitionDelay: idx * 0.07 + 's',
        }"
      />
    </div>

    <!-- <div class="test" @click="toggleAni">TOGGLE</div> -->
  </div>
</template>
<script>
import {
  TYPE_ANIMTAION_NORMAL,
  TYPE_ANIMATION_SPIRAL,
} from "../constant/types";

export default {
  props: {
    imgList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 1:logo
    // 2:菊花
    animationType: {
      type: String,
      default: TYPE_ANIMTAION_NORMAL,
    },
  },
  data() {
    return {
      animationClass: "",
      playAni: false,
    };
  },
  created() {
    this.animationClass =
      this.animationType === TYPE_ANIMATION_SPIRAL ? "ani-type2" : "ani-type1";
  },
  methods: {
    toggleAni() {
      this.playAni = !this.playAni;
    },
    playAnimation() {
      this.playAni = true;
    },
  },
};
</script>
<style lang="scss"  scoped>
  .animation-group {
    width: 100%;
    height: 100%;

    &__item {
      position: absolute;
    }

    .ani-x {
      opacity: 1 !important;
      transform: translate(0) scale(1) !important;
    }
    .ani-y {
      opacity: 1 !important;
      transform: translate(0) scale(1) !important;
    }
  }

  .ani-type1 {
    .g-item {
      opacity: 0;
      transition-duration: 0.4s;
      transition-timing-function: ease-out;
      transform: translateX(-100%);
      .g-inner {
        transition-duration: 0.4s;
        transition-timing-function: ease-in;
        transform: translateY(-100%) scale(0.8);
      }
    }
  }

  .ani-type2 {
    .g-item {
      opacity: 0;
      transition-duration: 0.5333s;
      .g-inner {
        transition-duration: 0.5333s;
      }
    }

    .g-item:nth-of-type(1) {
      transition-timing-function: ease-in;
      transform: translateX(100%);
      .g-inner {
        transition-timing-function: ease-out;
        transform: translateY(60%) scale(0.8);
      }
    }
    .g-item:nth-of-type(2) {
      transform: translateX(-50%);
      transition-timing-function: ease-out;
      .g-inner {
        transition-timing-function: ease-in;
        transform: translateY(100%) scale(0.8);
      }
    }
    .g-item:nth-of-type(3) {
      transform: translateX(-100%);
      transition-timing-function: ease-out;
      .g-inner {
        transition-timing-function: ease-in;
        transform: translateY(60%) scale(0.8);
      }
    }
    .g-item:nth-of-type(4) {
      transform: translateX(-100%);
      transition-timing-function: ease-in;
      .g-inner {
        transition-timing-function: ease-out;
        transform: translateY(-60%) scale(0.8);
      }
    }
    .g-item:nth-of-type(5) {
      transform: translateX(50%);
      transition-timing-function: ease-out;
      .g-inner {
        transition-timing-function: ease-in;
        transform: translateY(-100%) scale(0.8);
      }
    }
    .g-item:nth-of-type(6) {
      transform: translateX(100%);
      transition-timing-function: ease-out;
      .g-inner {
        transition-timing-function: ease-in;
        transform: translateY(-60%) scale(0.8);
      }
    }
  }
</style>
